import {
  ADD_SEMAPHORE,
  EDIT_INFOCARD,
  EDIT_SEMAPHORE,
  EDIT_RAIL_CHAINS,
  INIT_INFOCARDS,
  INIT_RAIL_CHAINS,
  DELETE_RAIL_CHAINS,
  ADD_RAIL_CHAINS,
  INIT_ADJACENCY,
  DELETE_ADJACENCY,
  INIT_SEMAPHORES,
  DELETE_SEMAPHORE,
  SET_ADJACENCY,
  CLEAR_ADJACENCY_STATE,
  CLEAR_RAIL_CHAINS_STATE,
  CLEAR_SEMAPHORES_STATE,
  EDIT_MODE,
  CLEAR_INFOCARDS,
} from '../type';
import axiosInstance from '../../config/axios.config';
import { success } from './loader.action';
import { downloadFile } from '../../utils/downloadFile';
import { addError } from './error.action';

export const clearInfocards = () => ({
  type: CLEAR_INFOCARDS,
  payload: [],
});

export const initInfocards = (infocards) => ({
  type: INIT_INFOCARDS,
  payload: infocards,
});

// получение всех инфокарт
export const initInfocardsFromServer = (query) => async (dispatch) => {
  try {
    const result = await axiosInstance(`/api/infocards${query}`);

    if (result.data && result.status === 200) {
      dispatch(initInfocards(result.data));
      return result; // Возвращаем данные для использования в компоненте
    }
  } catch (error) {
    console.log(error);
  }
};

// добавление новой инфокарты
export const addInfocardFromServer = (infocard) => async (dispatch, getState) => {
  try {
    const lastQuery = getState().lastQuery; // Достаём query из стейта
    const response = await axiosInstance.post(`/api/infocards`, infocard);
    if (response?.status === 201) {
      dispatch(clearInfocards());
      dispatch(initInfocardsFromServer(lastQuery)); // Повторный запрос с сохранённым query
      dispatch(success());
    }
  } catch (error) {
    console.log(error);
  }
};

// редактирование инфокарты
export const updateInfocardFromServer = (infocard, infocardId) => async (dispatch) => {
  try {
    const response = await axiosInstance.patch(`/api/infocards/${infocardId}`, infocard);
    if (response?.status === 200) {
      const { data } = await axiosInstance(`/api/infocards?station=${infocardId}&limit=50&offset=0`);
      dispatch({ type: EDIT_INFOCARD, payload: data?.[0] });
      dispatch(success());
    }
  } catch (error) {
    console.log(error);
  }
};

export const requestRailChains = (station) => {
  return async function (dispatch) {
    try {
      const resp = await axiosInstance.get(`/api/stations/${station}/rail_chains`, { responseType: 'json' });
      dispatch({ type: INIT_RAIL_CHAINS, payload: resp.data });
    } catch (e) {
      console.error('Error during GET ');
    }
  };
};

// добавление нового светофора в стейт
export const editMode = (payload) => ({
  type: EDIT_MODE,
  payload: payload,
});

export const editModeFromServer = (stationId, payload) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`/api/stations/${stationId}/disable`, payload);
    if (response.status === 201) {
      dispatch(editMode({ ...payload, stationId }));
    }
  } catch (error) {
    console.log(error);
  }
};

// Добавление нового справочника
export const newReferenceFromServer = (payload) => async (dispatch, getState) => {
  try {
    const lastQuery = getState().lastQuery; // Достаём query из стейта
    const response = await axiosInstance.post('/api/infocards/upload', payload, {
      headers: { 'Content-Type': 'multipart/form-data', 'Skip-Interceptor': 'true' },
    });

    if (response.status === 200) {
      dispatch(clearInfocards());
      dispatch(initInfocardsFromServer(lastQuery)); // Повторный запрос с сохранённым query
      return response.data; // Возвращаем данные из ответа
    }
  } catch (error) {
    console.log(error);
    throw error; // Бросаем ошибку для обработки в месте вызова
  }
};

// добавление новой рельсовой цепи
export const addRailChainsFromServer = (stationId, railChain) => async (dispatch) => {
  try {
    const { data } = await axiosInstance.post(`/api/stations/${stationId}/rail_chains`, railChain);
    if (data) {
      dispatch({ type: ADD_RAIL_CHAINS, payload: { stationId, rail: data } });
      dispatch(success());
    }
  } catch (error) {
    console.log(error);
  }
};

// изменение рельсовых цепей
export const updateRailChainsFromServer = (station, railChains) => async (dispatch) => {
  try {
    const { data } = await axiosInstance.patch(`/api/stations/${station}/rail_chains`, railChains);
    if (data) {
      dispatch({ type: EDIT_RAIL_CHAINS, payload: { station, railChains: data } });
      dispatch(success());
    }
  } catch (error) {
    console.log(error);
  }
};

// удаление рельсовой цепи
export const deleteRailChainsFromServer = (station, id) => async (dispatch) => {
  try {
    const resp = await axiosInstance.delete(`/api/stations/${station}/rail_chains/${id}`);
    if (resp.status === 200) {
      dispatch(success());
      dispatch({ type: DELETE_RAIL_CHAINS, payload: { id } });
    }
  } catch (error) {
    console.log(error);
  }
};

// очистка стейта РЦ
export const clearRailChainsState = (statuses, path) => ({
  type: CLEAR_RAIL_CHAINS_STATE,
  payload: [],
});

// получение всех смежностей по станции
export const initAdjacencyFromServer = (station) => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get(`/api/stations/${station}/rail_chains/all/adjacency`);
    dispatch({ type: INIT_ADJACENCY, payload: data });
  } catch (error) {
    console.error(error);
  }
};

// удаление смежности
export const deleteAdjacencyFromServer = (station, railId) => async (dispatch) => {
  try {
    const resp = await axiosInstance.delete(`/api/stations/${station}/rail_chains/${railId}/adjacency`);
    if (resp.status === 200) {
      dispatch(success());
      dispatch({ type: DELETE_ADJACENCY, payload: railId });
    }
  } catch (error) {
    console.log(error);
  }
};

// очистка стейта смежности
export const clearAdjacencyState = (statuses, path) => ({
  type: CLEAR_ADJACENCY_STATE,
  payload: [],
});

//изменение смежностей
export const setAdjacencyState = (payload) => ({
  type: SET_ADJACENCY,
  payload: payload,
});

//изменение смежностей
export const saveAdjacencyFromServer =
  ({ payload, stationId, railChainId }) =>
  async (dispatch) => {
    try {
      const resp = await axiosInstance.post(`/api/stations/${stationId}/rail_chains/${railChainId}/adjacency`, payload);
      if (resp?.status === 201) {
        dispatch(setAdjacencyState(resp?.data?.[0]));
        dispatch(success());
      }
    } catch (error) {
      console.log(error);
    }
  };

export const getXlsxFileFromServer = (stationId, stationName) => async (dispatch) => {
  try {   
    const res = await axiosInstance.post(`/api/stations/${stationId}/xlsx`, {}, { responseType: 'blob' });
    const data = res.data;
    if (data) {
      const fileName = `${stationName || 'Справочник'}.xlsx`;
      downloadFile(data, fileName);
    }
  } catch (error) {
    const message = 'Возникла непредвиденная ошибка, обратитесь к администратору системы.';
    dispatch(addError({ error: message }));
    console.log(error);
  }
};

export const getZipFileFromServer = (stationId, fileName) => async (dispatch) => {
  try {
    const res = await axiosInstance.post(`/api/stations/${stationId}/zip`, {}, { responseType: 'blob' });
    const data = res.data;
    if (data) {
      downloadFile(data, `${fileName || 'Справочник'}.zip`);
    }
  } catch (error) {
    const message = 'Возникла непредвиденная ошибка, обратитесь к администратору системы.';
    dispatch(addError({ error: message }));
    console.log(error);
  }
};

export const getDataCheckResultFromServer = (stationId, stationName) => async (dispatch) => {
  try {
    const res = await axiosInstance.post(`/api/stations/${stationId}/check`, {}, { responseType: 'blob' });
    const data = res.data;
    if (data) {
      const fileName = `${stationName || 'result'}.xlsx`;
      downloadFile(data, fileName);
    }
  } catch (error) {
    const message = 'Возникла непредвиденная ошибка, обратитесь к администратору системы.';
    dispatch(addError({ error: message }));
    console.log(error);
  }
};

export const requestSemaphores = (station) => async (dispatch) => {
  try {
    const resp = await axiosInstance.get(`/api/stations/${station}/semaphores`, { responseType: 'json' });
    dispatch({ type: INIT_SEMAPHORES, payload: resp.data });
  } catch (e) {
    console.error(`Error during GET:`, e);
  }
};

// очистка стейта семафоров
export const clearSemaphoresState = (statuses, path) => ({
  type: CLEAR_SEMAPHORES_STATE,
  payload: [],
});

// добавление нового светофора в стейт
export const addSemaphore = (semaphor) => ({
  type: ADD_SEMAPHORE,
  payload: semaphor,
});

// добавление нового светофора
export const newSemaphoreFromServer = (payload, stationId) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`/api/stations/${stationId}/semaphores`, payload);
    if (response.status === 201) {
      dispatch(addSemaphore(response.data));
      dispatch(success());
    }
  } catch (error) {
    const message = error?.response?.data || 'Возникла непредвиденная ошибка, обратитесь к администратору системы.';
    dispatch(addError(message));
    console.log(error);
  }
};

// добавление измененного светофора в стейт
export const editSemaphore = (semaphor) => ({
  type: EDIT_SEMAPHORE,
  payload: semaphor,
});

// изменение  светофора
export const editSemaphoreFromServer =
  ({ payload, semaphoreId, stationId }) =>
  async (dispatch) => {
    try {
      const response = await axiosInstance.patch(`/api/stations/${stationId}/semaphores/${semaphoreId}`, payload);
      if (response.status === 200) {
        dispatch(editSemaphore(response.data));
        dispatch(success());
      }
    } catch (error) {
      const message = error?.response?.data || 'Возникла непредвиденная ошибка, обратитесь к администратору системы.';
      dispatch(addError(message));
      console.log(error);
    }
  };

// удаление светофора
export const deleteSemaphore = (semaphoreId) => ({
  type: DELETE_SEMAPHORE,
  payload: semaphoreId,
});
// удаление светофора
export const deleteSemaphoreFromServer = (semaphoreId, stationId) => async (dispatch) => {
  try {
    const response = await axiosInstance.delete(`/api/stations/${stationId}/semaphores/${semaphoreId}`);
    if (response.status === 200) {
      dispatch(deleteSemaphore(semaphoreId));
      dispatch(success());
    }
  } catch (error) {
    const message = error?.response?.data || 'Возникла непредвиденная ошибка, обратитесь к администратору системы.';
    dispatch(addError(message));
    console.log(error);
  }
};
